import { Check } from 'lucide-react';

/**
 * A blue verification badge similar to Twitter's style with a white tick.
 */
export default function VerificationBadge({ size = 18 }) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: '#1DA1F2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Check color="#fff" size={size * 0.6} strokeWidth={3} />
    </div>
  );
}